<template>
  <div>
    <template v-if="contents">
      <div :class="['component', previewSize]" :style="hideAll ? 'display:none' : ''">
        <div @click="isEditing = !isEditing">

          <section :class="sectionClassArray" :style="sectionStyle">
            <div :class="containerClassArray">
              <h2 class="Table1-h2">{{ contents.heading.text }}</h2>
              <p class="Table1-p">{{ contents.paragraph.text }}</p>
              <table class="table">
                <thead class="thead" :style="getCustomHeadColorStyle">
                  <tr class="tr">
                    <template v-for="(row, rowIndex) in contents.table[0]">
                      <template v-if="row.href">
                        <th class="th px2 py1"><a class="inline-block theme-accent-color text-decoration-underline" :style="getCustomLinkColorStyle" :href="row.href">{{ row.text }}</a></th>
                      </template>
                      <template v-else>
                        <th class="th px2 py1">{{ row.text }}</th>
                      </template>
                    </template>
                  </tr>
                </thead>
                <tbody class="tbody" :style="getCustomBodyColorStyle">
                  <template v-for="(row, rowIndex) in contents.table">
                    <template v-if="rowIndex > 0">
                      <tr class="tr" :style="rowIndex % 2 === 0 ? getCustomAltColorStyle : ''">
                        <template v-for="(column, columnIndex) in row">
                          <!-- <td class="td px2 py1">{{ column.text }}</td> -->
                          <template v-if="column.href">
                            <td class="td px2 py1"><a class="inline-block theme-accent-color text-decoration-underline" :style="getCustomLinkColorStyle" :href="column.href">{{ column.text }}</a></td>
                          </template>
                          <template v-else>
                            <td class="td px2 py1">{{ column.text }}</td>
                          </template>
                        </template>
                      </tr>
                    </template>
                  </template>
                </tbody>
              </table>
              <p class="Table2-note">{{ contents.note.text }}</p>
            </div>
          </section>

        </div>
      </div>
      <el-form :class="['component-contents-form', ' p2', lock ? 'hide' : isEditing ? 'show' : 'hide']" :model="contents">
        <h2>コンポーネントのコンテンツを編集</h2>
        <el-form-item label="テーブルの見出し" :label-width="labelWidth">
          <el-input type="textarea" :autosize="{minRows:2}" v-model="contents.heading.text" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="テーブルの説明" :label-width="labelWidth">
          <el-input type="textarea" :autosize="{minRows:2}" v-model="contents.paragraph.text" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="テーブルの補足説明" :label-width="labelWidth">
          <el-input type="textarea" :autosize="{minRows:2}" v-model="contents.note.text" auto-complete="off"></el-input>
        </el-form-item>
        <div>
          <table class="table">
            <thead class="thead">
              <tr class="tr">
                <th><el-button type="primary" icon="el-icon-delete" @click="deleteRow(0)"></el-button></th>
                <template v-for="(row, rowIndex) in contents.table[0]">
                  <th class="th">
                    <div class="flex column">
                      <el-input v-model="contents.table[0][rowIndex].text"></el-input>
                      <el-input v-model="contents.table[0][rowIndex].href" placeholder="リンク先URL"></el-input>
                    </div>
                  </th>
                </template>
                <th><el-button type="primary" icon="el-icon-circle-plus-outline" @click="addRow(0)"></el-button></th>
              </tr>
            </thead>
            <tbody class="tbody">
              <template v-for="(row, rowIndex) in contents.table">
                <template v-if="rowIndex > 0">
                  <tr class="tr">
                    <td><el-button type="primary" icon="el-icon-delete" @click="deleteRow(rowIndex)"></el-button></td>
                    <template v-for="(column, columnIndex) in row">
                      <td class="td">
                        <div class="flex column">
                          <el-input v-model="contents.table[rowIndex][columnIndex].text"></el-input>
                          <el-input v-model="contents.table[rowIndex][columnIndex].href" placeholder="リンク先URL"></el-input>
                        </div>
                      </td>
                    </template>
                    <td><el-button type="primary" icon="el-icon-circle-plus-outline" @click="addRow(rowIndex)"></el-button></td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </div>
        <el-form-item label="コンポーネント配置順序" :label-width="labelWidth" class="mt5">
          <el-input-number v-model="newPosition" controls-position="right" :min="1" :max="positionMax"></el-input-number><span class="pl4">1から{{ positionMax }}まで</span>
        </el-form-item>
        <el-form-item label="テーブルヘッダーの背景色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.head.isCustom">テーブルヘッダー（1行目）の背景色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.head.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.head.color" show-alpha></el-color-picker>
            <span>{{ contents.head.color }}</span>
          </div>
        </el-form-item>
        <el-form-item label="テーブルボディの背景色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.body.isCustom">テーブルボディ（2行目以降）の背景色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.body.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.body.color" show-alpha></el-color-picker>
            <span>{{ contents.body.color }}</span>
          </div>
        </el-form-item>
        <el-form-item label="テーブルボディの交互の背景色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.alt.isCustom">テーブルボディ（2行目以降）の交互の背景色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.alt.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.alt.color" show-alpha></el-color-picker>
            <span>{{ contents.alt.color }}</span>
          </div>
        </el-form-item>
        <el-form-item label="リンクの文字色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.link.isCustom">リンクの文字色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.link.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.link.color" show-alpha></el-color-picker>
            <span>{{ contents.link.color }}</span>
          </div>
        </el-form-item>
        <el-form-item label="スライド上下の余白" :label-width="labelWidth">
           <el-slider v-model="contents.padding.y" :step="1" :min="0" :max="10"></el-slider>
        </el-form-item>
        <el-form-item label="スライド背景色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.bg.isCustom">スライドの背景色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.bg.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.bg.color" show-alpha></el-color-picker>
            <span>{{ contents.bg.color }}</span>
          </div>
        </el-form-item>
        <div class="component-contents-controller flex justify-end items-center">
          <component-form-footer @delete="deleteComponent()" @cancel="isEditing = false" @update="updateComponent()"></component-form-footer>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import ComponentBase from '@/components/mixins/ComponentBase'

export default {
  name: 'table-1',
  mixins: [ComponentBase],
  data: function () {
    return {
      labelWidth: '210px'
    }
  },
  computed: {
    getCustomHeadColorStyle: function () {
      return this.contents.head.isCustom ? `background-color:${this.contents.head.color}` : ''
    },
    getCustomHeadColorClass: function () {
      return this.contents.head.isCustom ? `${this.meta.file}-${this._uid}-thead-bg` : ''
    },
    getCustomBodyColorStyle: function () {
      return this.contents.body.isCustom ? `background-color:${this.contents.body.color}` : ''
    },
    getCustomBodyColorClass: function () {
      return this.contents.body.isCustom ? `${this.meta.file}-${this._uid}-tbody-bg` : ''
    },
    getCustomAltColorStyle: function () {
      return this.contents.alt.isCustom ? `background-color:${this.contents.alt.color}` : ''
    },
    getCustomAltColorClass: function () {
      return this.contents.alt.isCustom ? `${this.meta.file}-${this._uid}-talt-bg` : ''
    },
    getCustomLinkColorStyle: function () {
      return this.contents.link.isCustom ? `color:${this.contents.link.color}` : ''
    },
    getCustomLinkColorClass: function () {
      return this.contents.link.isCustom ? `${this.meta.file}-${this._uid}-link-color` : 'theme-accent-color'
    },
    getCustomBgColorStyle: function () {
      return this.contents.bg.isCustom ? `background-color:${this.contents.bg.color}` : ''
    },
    getCustomBgColorClass: function () {
      return this.contents.bg.isCustom ? `${this.meta.file}-${this._uid}-bg` : 'theme-base-bg-color'
    },
    src: function () {
    }
  },
  methods: {
    addRow: function (index) {
      this.contents.table.splice(index + 1, 0, [{text: '', href: ''}, {text: '', href: ''}])
    },
    deleteRow: function (index) {
      this.contents.table.splice(index, 1)
    },
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function (contents) {
      // theadの中身
      const tableHead = contents.table.reduce((acc, row, rowIndex) => {
        if (rowIndex > 0) return acc
        const innerTr = row.reduce((prev, column, columnIndex) => {
          const innerCell = column.href ? `<a class="inline-block text-decoration-underline ${this.getCustomLinkColorClass}" href="${column.href}">${column.text}</a>` : column.text
          return prev + `<th class="th px2 py1">${innerCell}</th>`
        }, '')
        return `<tr class="tr">${innerTr}</tr>`
      }, '')

      // tbodyの中身
      const tableBody = contents.table.reduce((acc, row, rowIndex) => {
        if (rowIndex === 0) return acc
        const innerTr = row.reduce((prev, column, columnIndex) => {
          const innerCell = column.href ? `<a class="inline-block text-decoration-underline ${this.getCustomLinkColorClass}" href="${column.href}">${column.text}</a>` : column.text
          return prev + `<td class="td px2 py1">${innerCell}</td>`
        }, '')
        return acc + `<tr class="tr">${innerTr}</tr>`
      }, '')

      return `
      <section id="${this.sectionId}" class="${this.sectionClass}">
        <div class="${this.containerClass}">
          <h2 class="${this.meta.file}-h2">${contents.heading.text}</h2>
          <p class="${this.meta.file}-p">${contents.paragraph.text}</p>
          <table class="table">
            <thead class="thead">${tableHead}</thead>
            <tbody class="tbody">${tableBody}</tbody>
          </table>
          <p class="${this.meta.file}-note">${contents.note.text}</p>
        </div>
      </section>
      `.trim().replace(/>\s+</g, '><')
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function (contents) {
      let layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!./${this.meta.file}.scss`)
      let theme = ''
      if (contents.head.isCustom) theme += `.${this.meta.file}-${this._uid} thead {${this.getCustomHeadColorStyle}}`
      if (contents.body.isCustom) theme += `.${this.meta.file}-${this._uid} tbody {${this.getCustomBodyColorStyle}}`
      if (contents.alt.isCustom) theme += `.${this.meta.file}-${this._uid} tbody tr:nth-child(even) {${this.getCustomAltColorStyle}}`
      if (contents.link.isCustom) theme += `.${this.meta.file}-${this._uid}-link-color {${this.getCustomLinkColorStyle}}`
      if (contents.bg.isCustom) theme += `.${this.meta.file}-${this._uid} {${this.getCustomBgColorStyle}}`
      return {layout, theme}
    }
  },
  created: async function () {
    if (!this.posts.length) await this.$store.dispatch('wordpress/posts/fetch')

    // migration
    if (!this.contents.note) this.contents.note = {text: ''}
    if (!this.contents.padding) this.contents.padding = {y: 4}
  }
}
</script>

<style lang="scss" scoped>
.native {
  @import './Table1.scss';
}
.smartphone,
.tablet,
.desktop {
  @import './Table1.s.scss';
}
.tablet,
.desktop {
  @import './Table1.m.scss';
}
.desktop {
  @import './Table1.l.scss';
}

</style>


// WEBPACK FOOTER //
// src/components/contents/Table1/Table1.vue